import { AxiosError } from 'axios';
import { getErrorNavigate } from 'src/compass/site/components';
import { paths } from 'src/compass/site/routes';

function onErrorBaseHandler(error: AxiosError<any>) {
  const { response, code } = error;
  const errorNavigate = getErrorNavigate()

  if (code === 'ERR_NETWORK' || code === 'ERR_NETWORK_ACCESS_DENIED') {
    return errorNavigate(paths.page503); // Stop further execution
  }

  if (response) {
    const { status, data } = response;
    if (status === 401 || status === 403) {
      if (data === 'Token expired') {
        return errorNavigate(paths.logoutPage); // Stop further execution
      }

      return errorNavigate(paths.page401); // Stop further execution
    }
  }
  return error;
}

export function onErrorPermissionsHandler(error: AxiosError<any>) {
  const errorNavigate = getErrorNavigate()
  const errorFromDefault = onErrorBaseHandler(error);
  if (errorFromDefault) errorNavigate(paths.page500);
}

export function onErrorDefaultHandler(error: AxiosError<any>) {
  const errorFromDefault = onErrorBaseHandler(error);
  if (!errorFromDefault) {
    return undefined; // Error has been handled by onErrorBaseHandler
  }

  const { response } = errorFromDefault;

  if (response) {
    const { status, data } = response;

    if (status === 400 || status === 409 || status === 500) {
      // BE error bodies come in a few shapes:
      //  - ASP.NET ModelState validation: { errors: { Field: ["msg", ...], ... } }
      //  - Custom controller: { message: "..." } (e.g. EnvironmentController)
      //  - ProblemDetails: { title: "...", detail: "..." }
      //  - Plain string body
      // Object.values(undefined) throws "Cannot convert undefined or null to object",
      // which used to mask the real error - guard before introspecting.
      const errorsObj = data?.errors;
      const flattened = errorsObj && typeof errorsObj === 'object'
        ? Object.values(errorsObj).flat().filter(Boolean).join('\n ')
        : '';
      const errorMessage =
        flattened
        || data?.message
        || data?.Message
        || data?.detail
        || data?.title
        || (typeof data === 'string' ? data : '')
        || 'Something went wrong';
      // `code` is an optional fixed name for the error (FrontendMessageException.Code) - most
      // have none - kept so a caller can act on the error rather than only show it.
      return new AxiosError(errorMessage, data?.code);
    }
  }

  return error;
}
